import { requestApi } from '../util/network'

// 获取当前店铺所有代金券
export const getStoreVoucher =
    (storeId) =>
      requestApi(
        '/Voucher/voucher_tpl_list',
        'POST',
        {
          'store_id': storeId, // 所属店铺
          'gettype': 'points'
        }
      )
// 领取取代金券
export const receiveVoucher =
    (tid) =>
      requestApi(
        '/Membervoucher/voucher_point',
        'POST',
        {
          'tid': tid
        },
        'member'
      )


